module.exports = __webpack_public_path__ + "img/priority-high.ba3da527.svg";